import { all, call, put, takeEvery } from "redux-saga/effects";
import { fetchInvitationDetails } from "../../networking/invitation/networking";
import * as types from "../types/invitation";

function* invitationValidation(action) {
  try {
    var response = yield call(fetchInvitationDetails, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_VALIDATE_INVITATION,
        data: response.payload,
      });
    } else {
      throw new Error("Kunne ikke fullføre registrering.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_VALIDATE_INVITATION, message: e.error });
  }
}

function* registrationSaga() {
  yield all([
    takeEvery(types.REQUEST_VALIDATE_INVITATION, invitationValidation),
  ]);
}

export default registrationSaga;
